var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BottomCharts"},[_c('PublicEcharts',{attrs:{"id":"BottomCharts","chartsData":_vm.orderData,"type":'ringChart',"options":_vm.dealOption(),"usePropsOptions":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }